import React from 'react';
import {
  Link,
  Bootstrap
} from '../../components';

/**
 * 导航菜单
 */
export default class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind();
  }

  componentDidMount() {
    //this.loadDataFromServer();
    let navbarFixed = document.getElementsByClassName('navbar-fixed-top');
    if (navbarFixed.length === 1){
      document.body.style.marginTop = 60 + "px";
    }
  }

  loadDataFromServer() { 
  }

  handleSelect() {
  }

  render() { 
    return (
      <nav className="navbar navbar-inverse navbar-fixed-top" role="navigation">
        <Bootstrap.Container>
          <div className="navbar-header">
            <button 
              type="button" 
              className="navbar-toggle collapsed" 
              data-toggle="collapse" 
              data-target="#bs-example-navbar-collapse-1" 
              aria-expanded="false" >
              <span className="sr-only">Toggle navigation</span> 
              <span className="icon-bar"></span> 
              <span className="icon-bar"></span> 
              <span className="icon-bar"></span> 
            </button>
            <Link className="navbar-brand" data={this.props.data.brand} />
          </div>
          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1"> 
            <Bootstrap.NavbarNav data={this.props.data.nav} />
            <form className="navbar-form navbar-left"> 
              <input type="text" className="form-control" placeholder="Search" /> 
            </form> 
            <Bootstrap.NavbarNav className="navbar-right" data={this.props.data.navRight} />
        </div>
        </Bootstrap.Container>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Navbar.js